export default {
  list: {
    create: "Nieuw bedrijf",
  },
  update: {
    delete: "Verwijder bedrijf",
  },
  create: {
    save: "Nieuw bedrijf aanmaken",
    cancel: "Annuleren",
    reset: "Reset gegevens",
  },
}
